import * as angular from 'angular';

import ChartGenerationFactory from './chartGeneration.factory';
import ChartServicesService from './chartServices.service';
import TierMicroChartService from './tierMicroChart.service';
import AptMacroChart from './aptMacroChart';
import AptMicroChart from './aptMicroChart';

// TODO: Get rid of the manual workarounds for name mangling below (that is, the [string, string, function]).
export default angular
  .module('charts', [])
  .factory('chartGenerationService', ChartGenerationFactory)
  .service('chartServices', ChartServicesService)
  .service('TierMicroChartService', TierMicroChartService)
  .directive('aptMacroChart', ['$log', 'chartGenerationService', AptMacroChart])
  .directive('aptMicroChart', ['$log', 'chartGenerationService', AptMicroChart])
  .value('highChartDefaults', {
    // TODO: move this to a highcharts module so that we only include on pages with charts
    // constants for providing defaults for highchart rendering

    minimalChartDefault: {
      chart: {
        type: 'columnrange',
        backgroundColor: '#ffffff',
        borderWidth: 1,
        borderColor: '#cccccc',
        showAxes: false,
        margin: 1,
        borderRadius: 0,
        style: { overflow: 'visible' }
      },
      loading: {
        labelStyle: {
          display: 'inline-block',
          color: '#8DC63F',
          fontWeight: 'normal',
          minHeight: '16px',
          lineHeight: '16px',
          paddingLeft: '24px',
          background:
            'url(/aptitude/images/ajax-loader.gif) no-repeat left center'
        }
      },
      title: {
        text: ''
      },
      series: [
        {
          type: 'line',
          name: '',
          data: []
        }
      ],
      lang: {
        noData: ''
      },
      noData: {
        style: {
          fontWeight: 'bold',
          fontSize: '15px',
          color: '#303030'
        }
      }
    },

    pricingChartSmallDefaults: {
      chart: {
        //          height: 100,
        //          width: 134,
        type: 'columnrange',
        backgroundColor: '#ffffff',
        borderWidth: 1,
        borderColor: '#cccccc',
        showAxes: false,
        margin: 1,
        borderRadius: 0,
        style: { overflow: 'visible' }
      },
      loading: {
        labelStyle: {
          display: 'inline-block',
          color: '#8DC63F',
          fontWeight: 'normal',
          minHeight: '16px',
          lineHeight: '16px',
          paddingLeft: '24px',
          background:
            'url(/aptitude/images/ajax-loader.gif) no-repeat left center'
        }
      },
      series: [],
      colors: [
        '#c77329',
        '#8ac342',
        {
          linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
          stops: [
            [0, 'rgba(255,255,255,.002)'],
            [0.01, 'rgba(255,255,255,.002)'],
            [0.01, '#8ac342'],
            [1, '#8ac342']
          ]
        }
      ],
      plotOptions: {
        columnrange: {
          borderWidth: 2,
          pointWidth: 5,
          grouping: false,
          minPointLength: 1,
          groupPadding: 0,
          enableMouseTracking: false,
          zIndex: 3
        },
        scatter: {
          zIndex: 5,
          color: 'transparent',
          marker: {
            symbol: 'circle',
            radius: 0
          }
        },
        arearange: {
          color: '#e0b0b0',
          zIndex: 0
        }
      },
      yAxis: {
        min: -100,
        max: 100,
        tickInterval: 150,
        tickColor: 'transparent',
        endOnTick: false,
        startOnTick: false,
        gridLineWidth: 1,
        lineWidth: 0,
        labels: {
          enabled: false
        },
        title: {
          text: null
        },
        plotBands: [
          {
            color: '#e0b0b0'
          }
        ]
      },
      xAxis: {
        labels: {
          enabled: false
        },
        title: {
          text: null
        },
        gridLineWidth: 0,
        tickWidth: 0,
        max: 9
      },
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      legend: {
        enabled: false
      },
      tooltip: {
        enabled: false
      }
    },

    bellGraphDefaults: {
      config: {
        templateName: 'contract-planning-summary',
        showSummary: false,
        showBenchmarkControls: false,
        showSavings: false,
        showLargeGraphOnClick: true
      },
      data: {
        currentSpend: 0,
        plannedSpend: 0,
        benchmarks: {
          all: {
            currentRanking: 0,
            plannedRanking: 0
          },
          similar: {
            currentRanking: 0,
            plannedRanking: 0
          }
        }
      }
    }
  }).name;
